import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import apiService from '../services/api';
import ConversationList from './ConversationList';
import ChatWindow from './ChatWindow';

const Chat = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  // C装ar conversaciones usando el nuevo sistema de rango
  const loadConversations = async (page = 1) => {
    try {
      setLoading(true);
      
      // Calcular startId y endId basado en la página
      // Página 1: startId=1, endId=20
      // Página 2: startId=21, endId=40
      // Página 3: startId=41, endId=60
      const startId = (page - 1) * pageSize + 1;
      const endId = page * pageSize;
      
      
      
      const response = await apiService.getConversations(startId, endId);
      
      
      
      setConversations(response.conversations || []);
      setCurrentPage(page);
      
      setError('');
    } catch (err) {
      setError('Error al cargar las conversaciones');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      loadConversations(1); // Cargar primera página
      
      // Si viene desde un perfil para iniciar chat
      const { startChatWith } = location.state || {};
      if (startChatWith) {
        // Crear objeto de conversación temporal
        const tempConversation = {
          id: startChatWith.id,
          username: startChatWith.username,
          first_name: startChatWith.name.split(' ')[0] || startChatWith.username,
          profile_picture: startChatWith.photoUrl,
          is_online: startChatWith.isOnline,
          last_message: '',
          last_message_time: new Date().toISOString(),
          last_sender_id: null,
          unread_count: 0
        };
        setSelectedConversation(tempConversation);
        // Limpiar el state para evitar que se repita
        window.history.replaceState({}, document.title);
      }
      
      // Polling cada 30 segundos para actualizar conversaciones (sin currentPage en las dependencias)
      const interval = setInterval(() => {
        setCurrentPage(prev => {
          loadConversations(prev);
          return prev;
        });
      }, 30000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, location.state]);

  const handleConversationSelect = (conversation) => {
    setSelectedConversation(conversation);
  };

  const handleBackToList = () => {
    setSelectedConversation(null);
    loadConversations(currentPage); // Recargar página actual al volver
  };

  const handleNewMessage = (message) => {
    // Actualizar la lista de conversaciones cuando se envía un mensaje
    loadConversations(currentPage);
  };

  const handlePageChange = (newPage) => {
    loadConversations(newPage);
  };

  if (!user) {
    return (
      <div className="flex items-center justify-center h-96">
        <p className="text-gray-600">Debes iniciar sesión para usar el chat</p>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto p-4">
      <h1 className="text-3xl font-bold text-center mb-8 text-pink-600">
        💬 Mensajes
      </h1>

      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        {selectedConversation ? (
          <ChatWindow
            conversation={selectedConversation}
            currentUser={user}
            onBack={handleBackToList}
            onNewMessage={handleNewMessage}
          />
        ) : (
          <ConversationList
            conversations={conversations}
            loading={loading}
            error={error}
            onConversationSelect={handleConversationSelect}
            onRefresh={() => loadConversations(currentPage)}
            onPageChange={handlePageChange}
            currentPage={currentPage}
          />
        )}
      </div>
    </div>
  );
};

export default Chat;
